import { Schema } from '@core/data/dto/schema';
import { getLocalMomentFromUtc } from '@core/utils/date-time';
import { FORMAT } from '@core/utils/formats';
import { DeliveryOrderQuoteManager } from './delivery-order-quote-manager';
import { DeliveryOrderQuoteDriver } from './delivery-order-quote-driver';

export const DeliveryOrderQuoteSchema = {
    id: Schema.String,
    service_provider: Schema.String,
    provider: Schema.String,
    provider_name: Schema.String,
    fee: Schema.Number,
    created: {
        map: 'created',
        mapImport: (value: string) =>
            getLocalMomentFromUtc(value, FORMAT.DATETIME_SERVER),
    },
    expires: {
        map: 'expires',
        mapImport: (value: string) =>
            getLocalMomentFromUtc(value, FORMAT.DATETIME_SERVER),
    },
    currency: Schema.String,
    dropoff_duration: Schema.Number,
    dropoff_eta: {
        map: 'dropoffEta',
        mapImport: (value: string) =>
            getLocalMomentFromUtc(value, FORMAT.DATETIME_SERVER),
    },
    pickup_eta: {
        map: 'pickupEta',
        mapImport: (value: string) =>
            getLocalMomentFromUtc(value, FORMAT.DATETIME_SERVER),
    },
    pickup_duration: Schema.Number,
    provisional: Schema.Boolean,
    drivers: [DeliveryOrderQuoteDriver],
    network: [DeliveryOrderQuoteManager],
};
